import { authService } from '@/auth/hooks';
import { fleetStore } from '@/lib/fleet-store';
import { Brand } from '@/components/brand';
import { Button } from '@/components/ui/button';
import { useNavigate } from '@tanstack/react-router';

/**
 * Shown when an authenticated user has zero fleet memberships. They can't
 * usefully use any other screen, so we route them here. The escape hatches
 * are: sign out, or wait for an invite.
 */
export function NoFleetsPage() {
  const navigate = useNavigate();

  async function handleSignOut() {
    await authService.logout();
    fleetStore.clear();
    await navigate({ to: '/login' });
  }

  return (
    <div className="min-h-screen flex flex-col bg-breaker-ground">
      <div className="h-1 bg-breaker-identity" />
      <main className="flex-1 grid place-items-center px-6 py-16">
        <div className="w-full max-w-md text-center">
          <Brand size="lg" />
          <p className="text-sm text-breaker-mute mt-2 tracking-wide uppercase">
            Dispatch
          </p>

          <div className="mt-10 surface rounded-lg p-8">
            <h1 className="text-base font-semibold text-breaker-ink mb-2">
              You&rsquo;re not in any fleets yet
            </h1>
            <p className="text-sm text-breaker-mute leading-relaxed">
              Dispatch needs a fleet to work with. Ask your fleet owner for an
              invite code, then redeem it at /join and refresh this page.
            </p>
            <div className="mt-6 pt-6 border-t border-breaker-line">
              <Button variant="secondary" size="sm" onClick={handleSignOut}>
                Sign out
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
